import Vue from 'vue'
export const EventBus = new Vue()

export const Topics = {
  NOTIFICATIONS: 'NOTIFICATIONS',
}

export const Types = {
  DANGER: 'error',
  INFO: 'success',
  WARNING: 'warn',
}
